(function () {
  var loaded = {};

  function loadScript(url) {
    if (!url || loaded[url]) {
      return loaded[url] || Promise.resolve();
    }

    loaded[url] = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = url;
      script.defer = true;
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return loaded[url];
  }

  function loadCartDrawer() {
    return loadScript(window.__cartDrawerAssetUrl);
  }

  function loadCartEngagement() {
    return loadScript(window.__cartEngagementAssetUrl).then(function () {
      if (typeof window.initCartEngagement === 'function') {
        window.initCartEngagement();
      }
    });
  }

  function shouldLoadCartEngagement() {
    try {
      return sessionStorage.getItem('driveto_cart_reminder_after_leave') === '1';
    } catch (e) {
      return false;
    }
  }

  function onInteraction(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('#cart-icon-bubble, cart-drawer, .header__cart-experience, [data-cart-reminder]')) {
      loadCartDrawer().catch(function () {});
      loadCartEngagement().catch(function () {});
    }
  }

  ['pointerdown', 'keydown', 'touchstart'].forEach(function (eventName) {
    document.addEventListener(eventName, onInteraction, { passive: true, capture: true });
  });

  window.addEventListener(
    'pageshow',
    function () {
      if (shouldLoadCartEngagement()) {
        loadCartEngagement().catch(function () {});
      }
    },
    { once: true },
  );
})();
